import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleHeroProps {
  article: Article;
}

export default function ArticleHero({ article }: ArticleHeroProps) {
  return (
    <section className="relative w-full bg-background-50 pt-24 pb-12 md:pt-32 md:pb-16">
      <div className="w-full max-w-4xl mx-auto px-6 md:px-10">
        <nav className="flex items-center gap-2 text-xs text-foreground-400 mb-6" aria-label="面包屑导航">
          <Link to="/" className="hover:text-accent-500 transition-colors">首页</Link>
          <i className="ri-arrow-right-s-line w-3 h-3 flex items-center justify-center" />
          <Link to={`/category/${article.categorySlug}`} className="hover:text-accent-500 transition-colors">
            {article.category}
          </Link>
          <i className="ri-arrow-right-s-line w-3 h-3 flex items-center justify-center" />
          <span className="text-foreground-700 truncate max-w-[200px]">{article.title}</span>
        </nav>

        <div className="flex flex-col items-center text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-6">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-500" />
            {article.category}
            <span className="text-accent-400">·</span>
            {article.publishDate}
          </div>

          <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight max-w-3xl">
            {article.title}
          </h1>

          <p className="mt-5 text-foreground-500 text-sm md:text-base leading-relaxed max-w-2xl">
            {article.excerpt}
          </p>

          <div className="flex items-center gap-3 mt-6">
            <button
              type="button"
              className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-bookmark-line w-4 h-4 flex items-center justify-center" />
              收藏
            </button>
            <button
              type="button"
              className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-full border-2 border-foreground-200 text-foreground-700 text-sm font-medium hover:border-foreground-400 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-share-forward-line w-4 h-4 flex items-center justify-center" />
              分享
            </button>
          </div>

          <div className="flex items-center gap-4 mt-4 text-xs text-foreground-400">
            <span className="flex items-center gap-1">
              <i className="ri-eye-line w-3.5 h-3.5 flex items-center justify-center" />
              {article.views.toLocaleString()}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-chat-3-line w-3.5 h-3.5 flex items-center justify-center" />
              {article.comments.toLocaleString()} 评论
            </span>
            <span>{article.readTime}</span>
          </div>
        </div>
      </div>
    </section>
  );
}